export const version = '5.4.1';
export const name = 'helia';
//# sourceMappingURL=version.js.map